module.exports = __webpack_public_path__ + "static/np_business_1019003_000000-823bf425be014b9e170b58ac462997d0.png";